//#region src/locales/ja/tamagotchi/stage.yaml
var data = {
	"operations": {
		"load-models": "モデルの読み込み",
		"load-models-status": {
			"loading": "読み込み中",
			"ready": "準備完了"
		}
	},
	"docs": { "theme": { "navbar": { "appearance": { "title": "外観" } } } },
	"controls-island": {
		"fade-on-hover": {
			"enable": "自動的に隠す",
			"disable": "常に表示"
		},
		"open-settings": "設定を開く",
		"open-chat": "チャットを開く",
		"refresh": "再読み込み",
		"center-main-window": "画面中央に移動",
		"open-hearing-controls": "聴覚コントロールを開く",
		"drag-to-move-window": "ウィンドウをドラッグして移動",
		"switch-to-light-mode": "ライトモードに切り替え",
		"switch-to-dark-mode": "ダークモードに切り替え",
		"pin-on-top": "ピン留め",
		"unpin-from-top": "ピン留めを外す",
		"switch-profile": "プロファイルを切り替え",
		"close": "閉じる",
		"expand": "展開",
		"collapse": "折りたたむ",
		"login": "サインイン",
		"logging-in": "サインイン中…",
		"account": "アカウント",
		"logout": "サインアウト"
	},
	"widgets": {
		"close": "ウィジェットを閉じる",
		"empty": {
			"title": "アクティブなウィジェットはありません",
			"description": "ツールまたはプラグインが生成すると、ここにウィジェットが表示されます。"
		},
		"loading": "ウィジェットを読み込み中…",
		"waiting": "\"{id}\" のウィジェット データを待機中…"
	},
	"notice": { "fade-on-hover": {
		"title": "ホバー時にフェード",
		"intro": "カーソルが近くを移動するとキャラクターが自動的にフェードアウトする。この仕組みは視界の妨げを抑えつつ、キャラクターを見失わないように保つ。",
		"opacity": "有効にすると、カーソルが近くに来た時に、{targets} の不透明度が {value} に下がります。",
		"toggle": "{controls}にカーソルを合わせて、もう一度 {icon} をクリックすることでオフに切り替えることができます。",
		"controls-label": "コントロールアイランド",
		"icon-label": "eye-slash アイコン",
		"targets": "キャラクターとUI",
		"confirm": "了解",
		"dont-show-again": "次回から表示しない",
		"preparing": "準備中…",
		"read-more": "続きを読む",
		"preview-title": "これは何？"
	} },
	"about": {
		"subtitle": "デスクトップ版",
		"current-version": "現在のバージョン",
		"common": { "cancel": "キャンセル" },
		"links": {
			"title": "リンク",
			"home": "ホーム",
			"documentation": "ドキュメント"
		},
		"update": {
			"lane": {
				"label": "アップデート チャンネル",
				"description": "追跡するリリース チャンネルを選択します",
				"placeholder": "アップデート チャンネルを選択"
			},
			"channels": {
				"auto": "自動",
				"stable": "安定版 (Stable)",
				"alpha": "アルファ版 (Alpha)",
				"beta": "ベータ版 (Beta)",
				"nightly": "ナイトリー版 (Nightly)",
				"canary": "カナリア版 (Canary)"
			},
			"status": {
				"downloading": "アップデートをダウンロード中...",
				"error-prefix": "エラー",
				"latest": "最新の状態です (v{version})。",
				"downloaded": {
					"windows": "サイレント インストール可能なアップデートの準備が完了しました (v{version})。",
					"restart": "再起動時にインストール可能なアップデートの準備が完了しました (v{version})。"
				}
			},
			"actions": {
				"download": "アップデートをダウンロード",
				"download-short": "ダウンロード",
				"confirm-download": "ダウンロードを確認",
				"check-for-updates": "アップデートを確認",
				"checking": "確認中…",
				"latest-version": "最新バージョン",
				"disabled-dev": "開発環境ではアップデートが無効化されています",
				"managed-by-store": "アップデートはアプリストアによって管理されています",
				"retry-check": "再確認",
				"restart-silent": "サイレント アップデートのために再起動",
				"restart-install": "再起動してアップデートをインストールする",
				"confirm-restart": "再起動を確認"
			},
			"dialog": {
				"title": "利用可能なアップデートがあります",
				"description": "新しいバージョン({version})が利用可能です。",
				"no-release-notes-markdown": "_リリースノートがありません。_"
			}
		}
	}
};
//#endregion
export { data as default };
